import { render } from "./Archives.vue?vue&type=template&id=386aa6b6&scoped=true"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"

import "./Archives.vue?vue&type=style&index=0&id=386aa6b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-386aa6b6"

export default script